/**
 * Canonical font-name normalization helpers, shared by:
 *  - svgFontMatcher  (import-time matching)
 *  - fontResolution  (runtime resolution)
 *  - fontCandidateResolver (unified pipeline)
 *
 * Treat this file as the only definition of what counts as "the same" font
 * name. If you change a rule here, both import-time and runtime agree.
 */

export function normalizeFontName(name: string): string {
  return name.replace(/['\s\-_]/g, '').toLowerCase();
}

export function tokenizeFontName(name: string): string[] {
  const parts = name.replace(/[-_]/g, ' ').split(/\s+/);
  const tokens: string[] = [];
  for (const part of parts) {
    const camelSplit = part.replace(/([a-z])([A-Z])/g, '$1 $2').split(/\s+/);
    tokens.push(...camelSplit.map((t) => t.toLowerCase()));
  }
  return tokens.filter((t) => t.length > 0);
}

export function tokenOverlap(tokensA: string[], tokensB: string[]): number {
  if (tokensA.length === 0 || tokensB.length === 0) return 0;
  const setA = new Set(tokensA);
  const setB = new Set(tokensB);
  let matches = 0;
  for (const token of setA) {
    if (setB.has(token)) matches++;
  }
  const denominator = Math.min(setA.size, setB.size);
  return denominator === 0 ? 0 : matches / denominator;
}
